// src/pages/products/Schematz.jsx
import React from 'react';
import ProductTemplate from '../../components/products/ProductTemplate';
import schematzHero from '../../assets/images/expertise.jpg';
import schematzProduct from '../../assets/images/expertise.jpg';

const Schematz = () => {
  const features = [
    { icon: '📊', title: 'Financial Management', description: 'General ledger, accounts payable/receivable, budgeting, and financial reporting' },
    { icon: '🏭', title: 'Supply Chain Management', description: 'Procurement, inventory control, order management, and supplier relationship management' },
    { icon: '👥', title: 'Human Resources Management', description: 'Employee records, payroll, recruitment, performance tracking, and benefits administration' },
    { icon: '🏗️', title: 'Manufacturing Management', description: 'Production planning, shop floor control, quality management, and BOM management' },
    { icon: '📈', title: 'Business Intelligence', description: 'Real-time dashboards, predictive analytics, and customizable reports' },
    { icon: '📦', title: 'Inventory Management', description: 'Real-time stock tracking, warehouse management, and automated reordering' },
    { icon: '🔗', title: 'CRM Integration', description: 'Customer relationship management, sales pipeline, and support ticketing' },
    { icon: '📋', title: 'Project Management', description: 'Project planning, resource allocation, time tracking, and milestone management' },
    { icon: '⚙️', title: 'Asset Management', description: 'Fixed asset tracking, maintenance scheduling, and depreciation calculation' },
    { icon: '📑', title: 'Document Management', description: 'Centralized document storage, version control, and approval workflows' },
    { icon: '🔒', title: 'Role-Based Access Control', description: 'Granular permissions and multi-level security protocols' },
    { icon: '📱', title: 'Mobile Accessibility', description: 'Access ERP data anywhere on any device' },
    { icon: '🔌', title: 'API-First Architecture', description: 'Seamless integration with third-party applications' },
    { icon: '🤖', title: 'Workflow Automation', description: 'Automate repetitive tasks and approval processes' },
    { icon: '🌐', title: 'Multi-Company Support', description: 'Manage multiple entities from a single instance' },
    { icon: '🌍', title: 'Multi-Currency & Localization', description: 'Global operations with multi-currency and tax compliance' }
  ];

  const benefits = [
    'Streamline operations across all departments with a unified platform',
    'Reduce operational costs by up to 40% through automation',
    'Make data-driven decisions with real-time analytics and insights',
    'Improve productivity with automated workflows and reduced manual tasks',
    'Enhance collaboration between departments with integrated data',
    'Ensure compliance with industry regulations and standards',
    'Scale your business without changing systems',
    'Gain complete visibility into your business performance'
  ];

  const industries = [
    'Construction', 'Manufacturing', 'Mining', 'Oil & Gas',
    'Food Industry', 'Logistics', 'Retail', 'Real Estate',
    'Healthcare', 'Education', 'Professional Services', 'Wholesale'
  ];

  const specifications = [
    { label: 'Deployment', value: 'Cloud-based (SaaS) / On-Premise / Hybrid' },
    { label: 'Platform', value: 'Web, iOS, Android, Desktop' },
    { label: 'Security', value: 'SOC 2 Type II, ISO 27001, GDPR Compliant' },
    { label: 'Integration', value: 'REST API, GraphQL, Webhooks, SSO' },
    { label: 'Support', value: '24/7 Priority Support' },
    { label: 'Updates', value: 'Continuous deployment with zero downtime' },
    { label: 'Languages', value: '20+ languages supported' },
    { label: 'Database', value: 'PostgreSQL / Oracle / SQL Server' },
    { label: 'Hosting', value: 'AWS, Azure, GCP, or On-Premise' },
    { label: 'Customization', value: 'Fully customizable modules and workflows' }
  ];

  const modules = [
    { name: 'Financials', description: 'Complete financial management suite', icon: '💰' },
    { name: 'Supply Chain', description: 'End-to-end supply chain visibility', icon: '🚚' },
    { name: 'Manufacturing', description: 'Production planning and control', icon: '🏭' },
    { name: 'HR & Payroll', description: 'Workforce management', icon: '👥' },
    { name: 'CRM', description: 'Customer relationship management', icon: '🤝' },
    { name: 'Projects', description: 'Project lifecycle management', icon: '📋' },
    { name: 'Inventory', description: 'Stock and warehouse management', icon: '📦' },
    { name: 'Analytics', description: 'Business intelligence and reporting', icon: '📊' }
  ];

  return (
    <ProductTemplate
      title="Schematz"
      badge="ERP SOLUTION"
      tagline="Your Comprehensive ERP Solution for Businesses"
      description="In today's fast-paced business environment, efficiency, adaptability, and real-time insights are critical for success. Schematz, the cutting-edge ERP solution by DOROTS Ltd, is designed to help businesses streamline operations, improve decision-making, and achieve sustainable growth."
      heroImage={schematzHero}
      productImage={schematzProduct}
      features={features}
      benefits={benefits}
      industries={industries}
      specifications={specifications}
      ctaText="Get Started with Schematz"
      ctaLink="/contact"
    />
  );
};

export default Schematz;